import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import {
  ThemeProvider,
  ToastProvider,
  Toaster,
  NotificationProvider,
} from '@sectepe/ui';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { BrandProvider } from './contexts/BrandContext';
// Design-System-CSS (--sec-* Tokens + .sec-* Klassen), das @sectepe/ui benoetigt.
import './index.css';

// Persistierte Theme-Praeferenz; ohne Wahl bleibt es bei der System-Praeferenz
// (prefers-color-scheme), die der ThemeProvider aufloest. Der ThemeToggle im
// Top-Bar schreibt `sec-theme`.
function initialTheme(): 'light' | 'dark' | 'system' {
  try {
    const v = localStorage.getItem('sec-theme');
    if (v === 'light' || v === 'dark') return v;
  } catch { /* storage optional */ }
  return 'system';
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      {/* @sectepe/ui-Wurzel: ThemeProvider aktiviert die .sec-scope + --sec-*
          Tokens, die AppShell/AppSwitcher/CommandPalette/NotificationCenter
          benoetigen. NotificationProvider haelt den (quelle-agnostischen)
          Benachrichtigungs-Zustand fuer das NotificationCenter im Top-Bar. */}
      <ThemeProvider defaultTheme={initialTheme()} defaultLanguage="de">
        {/* BrandProvider (White-Label): laedt /api/public/brand, setzt Titel,
            Favicon und --sec-* Farb-Tokens; Haus-Deployment bleibt unveraendert. */}
        <BrandProvider>
          <AuthProvider>
            <NotificationProvider>
              <ToastProvider>
                <App />
                <Toaster dismissLabel="Schliessen" />
              </ToastProvider>
            </NotificationProvider>
          </AuthProvider>
        </BrandProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
